export default __webpack_public_path__ + "static/media/1987.2e3ccece.png";